import { haversineDistanceKm } from "../../utils/geoDistance";

export const DEFAULT_TRIP_COST_SETTINGS = Object.freeze({
  consumptionLitersPer100Km: 7.2,
  fuelPricePerLiter: 2,
  // Participation legere a l'entretien du vehicule. Ce montant reste
  // volontairement modifiable par les personnes qui organisent le trajet.
  vehicleCostPerKm: 0.1,
  tolls: 0,
  occupants: 4,
});

export function estimateRoadDistanceKm(origin, destination, roadFactor = 1.45) {
  const directDistance = haversineDistanceKm(origin, destination);
  if (!Number.isFinite(directDistance)) return null;
  return Math.max(1, Math.round(directDistance * roadFactor));
}

export function estimateTolls(distanceKm) {
  return Number.isFinite(Number(distanceKm))
    ? Math.round(Math.max(0, Number(distanceKm)) * 0.085 * 2) / 2
    : 0;
}

// `values.distanceKm`/`values.tolls` restent toujours le trajet aller (c'est
// ce que l'itinéraire/l'estimation routière calcule) ; le rayon détermine
// uniquement comment ils sont comptés dans le total, pour ne pas fausser le
// champ affiché/modifiable par la personne qui saisit le trajet.
export function calculateTripCost(values = {}, { tripType = "oneway" } = {}) {
  const isRoundTrip = tripType === "roundtrip";
  const tripMultiplier = isRoundTrip ? 2 : 1;
  const distanceKm = Math.max(0, Number(values.distanceKm) || 0) * tripMultiplier;
  const consumptionLitersPer100Km = Math.max(0, Number(values.consumptionLitersPer100Km) || 0);
  const fuelPricePerLiter = Math.max(0, Number(values.fuelPricePerLiter) || 0);
  const vehicleCostPerKm = Math.max(0, Number(values.vehicleCostPerKm) || 0);
  const tolls = Math.max(0, Number(values.tolls) || 0) * tripMultiplier;
  const occupants = Math.max(1, Math.round(Number(values.occupants) || 1));
  const fuelCostPerKm = (consumptionLitersPer100Km / 100) * fuelPricePerLiter;
  const fuelCost = distanceKm * fuelCostPerKm;
  const vehicleCost = distanceKm * vehicleCostPerKm;
  const totalCost = fuelCost + vehicleCost + tolls;
  const pricePerPerson = totalCost / occupants;

  return {
    tripType: isRoundTrip ? "roundtrip" : "oneway",
    distanceKm,
    occupants,
    fuelCost,
    vehicleCost,
    tolls,
    totalCost,
    pricePerPerson,
    suggestedPrice: Math.round(pricePerPerson),
  };
}

export function formatEuro(value) {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(Number(value) || 0);
}
